import { cn } from '@/lib/utils';

interface ImageContainerProps extends React.HTMLAttributes<HTMLDListElement> {
  children: React.ReactNode;
  hasCaption?: boolean;
}

export default function ImageContainer(props: ImageContainerProps) {
  const { hasCaption = false, className, children } = props;

  return (
    <div
      className={cn(
        'relative w-full md:min-h-80',
        hasCaption && 'overflow-hidden rounded-2xl',
        className,
      )}
    >
      {children}
    </div>
  );
}
